// machineReducer.js
import {
    INIT_MACHINE_LIST_REQUEST_DASHBOARD,
    SET_MACHINE_LIST_DASHBOARD,
    ERROR_MACHINE_LIST_DASHBOARD,
    INIT_CHART_REQUEST_DASHBOARD,
    SET_CHART_DATA_DASHBOARD,
    ERROR_CHART_DATA_DASHBOARD,
} from './action';

const initialDashboardState = {
    chartData: [],
    error: null,
    isLoading: false,
    machinListByCompanyId: [],
};

const dashboardReducer = (state = initialDashboardState, action) => {
    switch (action.type) {
        case INIT_MACHINE_LIST_REQUEST_DASHBOARD:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case SET_MACHINE_LIST_DASHBOARD:
            return {
                ...state,
                machinListByCompanyId: action.payload,
                isLoading: false,
                error: null,
            };

        case ERROR_MACHINE_LIST_DASHBOARD:
            return {
                ...state,
                machinListByCompanyId: [],
                isLoading: false,
                error: action.payload,
            };

        case INIT_CHART_REQUEST_DASHBOARD:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case SET_CHART_DATA_DASHBOARD:
            return {
                ...state,
                chartData: action.payload,
                isLoading: false,
                error: null,
            };

        case ERROR_CHART_DATA_DASHBOARD:
            return {
                ...state,
                chartData: [],
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default dashboardReducer;
